import { useState } from "react";
import Slider from "react-slick";
import { Link } from "react-router-dom";
import '../App.css';
import RecentPost from "../RecentPost";
import ContactNumber from "../ContactNumber";
import { Helmet } from "react-helmet";

export default function Pginwagholi(){
    const [activeIndex, setActiveIndex] = useState(null);

    const toggleAccordion = (index) => {
      setActiveIndex(activeIndex === index ? null : index);
    };
    
   
    const faqs = [
      {
          question: "What types of rooms are available at Om Sai PG?",
          answer: "Om Sai PG offers single, double, and triple-sharing rooms, all equipped with essential furniture like beds, wardrobes, study tables, and chairs."
      },
      {
          question: "What is the rent for rooms at Om Sai PG?",
          answer: "The rent varies depending on the room type and facilities offered. However, we ensure that our rent is affordable and competitive for both students and working professionals."
      },
      {
          question: "Are meals provided at Om Sai PG?",
          answer: "Yes, we provide nutritious, home-cooked meals, including breakfast, lunch, and dinner. Our meals cater to a variety of dietary preferences and are prepared fresh every day."
      },
      {
          question: "Is Wi-Fi available at Om Sai PG?",
          answer: "Yes, high-speed Wi-Fi is available throughout the premises, allowing you to stay connected for both study and entertainment purposes."
      },
      {
          question: "How is the security at Om Sai PG?",
          answer: "We prioritize security with 24/7 CCTV surveillance and on-site security personnel to ensure the safety of all our residents."
      },
      {
          question: "Are laundry services available?",
          answer: "Yes, Om Sai PG provides laundry services for all residents, making it convenient for you to keep your clothes clean without any hassle."
      },
      {
          question: "Is there a parking facility available at Om Sai PG?",
          answer: "Yes, we offer ample parking space for residents who own vehicles, ensuring that your vehicle is safe and secure."
      },
      {
          question: "Can I book a room for a short stay?",
          answer: "Om Sai PG primarily caters to long-term stays, but we also accept short-term bookings based on availability. Please contact us for more details."
      },
      {
          question: "How far is Om Sai PG from the nearest transportation hub?",
          answer: "Om Sai PG is well-connected by public transport, with bus stops and railway stations within a short distance. You can easily access nearby areas in Pune."
      },
      {
          question: "Is there any additional cost for using amenities like Wi-Fi or meals?",
          answer: "No, the cost of Wi-Fi and meals is included in the rent. We offer a hassle-free experience without any hidden charges."
      }
  ];
  
  const testimonials = [
      {
          quote: "I have been staying at Om Sai PG for the past 6 months, and I can confidently say it's the best decision I made! The rooms are spacious, well-maintained, and have all the basic amenities required for a comfortable stay. The food is homely, and the management is extremely cooperative. The location in Wagholi is perfect as it is well connected to all major areas. I highly recommend Om Sai PG to anyone looking for a safe, clean, and comfortable place to stay.",
          author: "- Rajesh Kumar"
      },
      {
          quote: "Om Sai PG is by far the most pleasant PG experience I've had! The rooms are neat and tidy, and the staff is very helpful and friendly. The food is nutritious and made with care, just like home-cooked meals. The Wi-Fi and other facilities are reliable, making it perfect for both students and professionals. The location is also great, with easy access to public transport and shopping areas. I’m really happy with my stay here!",
          author: "- Priya Sharma"
      }
  ];
     

      const settings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 5000,
      };
    
    
    
    
    return(
        <>


<Helmet>
  {/* JSON-LD Structured Data */}
  <script type="application/ld+json">
    {JSON.stringify({
      "@context": "https://schema.org",
      "@type": "Organization",
      "name": "Om Sai PG",
      "description": "Om Sai PG offers affordable PG accommodations in Kharadi, Pune, with food, for students, working professionals, and residents, near Eon IT Park.",
      "url": "https://www.omsaipg.in/Pg-in-Wagholi",
      "logo": "https://www.omsaipg.in/images/logo.jpg",
      "image": "https://www.omsaipg.in/img/keyword-image/pg-in-wagholi.jpg",
      "contactPoint": [
        {
          "@type": "ContactPoint",
          "telephone": "+91 9763888448",
          "contactType": "Customer Service",
          "areaServed": "IN",
          "availableLanguage": "English",
        },
        {
          "@type": "ContactPoint",
          "telephone": "+91 9922248255",
          "contactType": "Customer Service",
          "areaServed": "IN",
          "availableLanguage": "English",
        },
      ],
      "aggregateRating": {
        "@type": "AggregateRating",
        "bestRating": "5",
        "worstRating": "1",
        "ratingValue": "4.7",
        "ratingCount": "250",
      },
      "email": "omsaipg@gmail.com",
      "address": {
        "@type": "PostalAddress",
        "streetAddress": "Tulja Bhavani Nagar, Lane No 7, Near Durga Mata Mandir",
        "addressLocality": "Kharadi",
        "addressRegion": "Maharashtra",
        "postalCode": "411014",
        "addressCountry": "IN",
      },
      "sameAs": [
        "https://www.facebook.com/omsaipg",
        "https://www.instagram.com/omsaipg",
        "https://www.linkedin.com/company/omsaipg"
      ],
      "priceRange": "INR 8,500-6000",
      "paymentAccepted": "Cash, UPI, Credit Card",
      "keywords": [
        "PG in Pune",
        "PG in Kharadi",
        "PG with food",
        "PG for students in Kharadi",
        "Boys Hostel in Kharadi",
        "Paying Guest Hostel in Kharadi"
      ],
      "openingHours": "Mo-Su 09:00-22:00"
    })}
  </script>

  {/* Title */}
  <title>
    Om Sai PG - Best PG Accommodation in Kharadi, Pune | Paying Guest with Food | PG for Students and Professionals
  </title>

  {/* Meta Tags */}
  <meta
    name="description"
    content="Om Sai PG offers affordable PG accommodations in Kharadi, Pune, with food included. Ideal for students, professionals, and residents."
  />
  <meta
    name="keywords"
    content="PG in Pune, PG in Kharadi, PG with food, PG for students in Kharadi, Boys Hostel in Kharadi, Paying Guest Hostel in Kharadi"
  />
  <meta name="robots" content="index, follow" />

  {/* Open Graph Tags */}
  <meta
    property="og:title"
    content="Om Sai PG - Best PG Accommodation in Kharadi Pune | PG with Food | Paying Guest in Kharadi"
  />
  <meta
    property="og:description"
    content="Looking for the best PG in Kharadi Pune? Om Sai PG offers comfortable and affordable accommodation for students, professionals, and residents with food included."
  />
  <meta property="og:image" content="https://www.omsaipg.in/img/keyword-image/pg-in-wagholi.jpg" />
  <meta property="og:url" content="https://www.omsaipg.in/Pg-in-Wagholi" />
  <meta property="og:type" content="website" />
</Helmet>

     <section class="section-breadcrumb padding-b-50">
        <div class="rx-breadcrumb-image bg-img1">
            <div class="rx-breadcrumb-overlay"></div>
            <div class="inner-breadcrumb-contact">
                <div class="main-breadcrumb-contact">
                    <div class="container">
                        <div class="row">
                            <div class="col-12">
                                <div class="rx-banner-contact">
                                    <h2>PG in Wagholi </h2>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="rx-banner-breadcrumb">
                    <div class="container">
                        <div class="row">
                            <div class="col-12">
                                <div class="breadcrumb-contact">
                                    <div class="main-heading">
                                        <h4> PG in Wagholi </h4>
                                    </div>
                                    <div class="last-contact">
                                        <ul>
                                            <li>
                                                <Link to="/">Home</Link>
                                            </li>
                                            <li> PG in Wagholi </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>

      {/* <!-- Page Banner End --> */}

      <div class="section-about padding-tb-50 keywordsection">
        <div className="container">
          <div className="row d-flex justify-content-around">
            <div className="col-12 col-md-8">
              <div className="keyword-img">
                <img src="img/keyword-image/pg-in-wagholi.jpg" className="img-fluid" alt="Pg-in-wagholi" />
              </div>
             
              <h1>Om Sai PG: The Best PG in Wagholi for Comfortable Living</h1>
<p>Look no further than Om Sai PG! Located at the prime location of Kharadi, near the Eon IT Park, Om Sai PG offers an ideal living space for both students and working professionals. Our PG provides excellent facilities that cater to the needs of every individual.</p>

<h2>Why Choose Om Sai PG in Wagholi?</h2>
<p>At Om Sai PG, we prioritize your comfort, safety, and convenience. With separate buildings for men and women, we ensure that every resident feels at home. Whether you're a student attending nearby educational institutions or a professional working at Eon IT Park, our PG offers the perfect balance of homely vibes and modern amenities.</p>

<h2>Key Facilities Provided at Om Sai PG</h2>
<p>We understand that when choosing a PG, having access to essential facilities is crucial. Here's a comprehensive list of what you can expect when you stay at Om Sai PG in Wagholi:</p>
<ul>
  <li><strong>Washing Machine:</strong> No need to worry about laundry! At Om Sai PG, we provide a washing machine for your convenience, ensuring your clothes are always fresh and clean.</li>
  <li><strong>High-Speed Wifi:</strong> Stay connected at all times with our fast and reliable Wifi. Whether you need to attend online classes, work remotely, or stream your favorite content, you will always have a stable internet connection.</li>
  <li><strong>TV in Each Room:</strong> Each room at Om Sai PG is equipped with a TV, so you can relax and unwind after a long day. Enjoy your favorite shows and movies in the comfort of your room.</li>
  <li><strong>24/7 Water Supply:</strong> Experience hassle-free living with round-the-clock water supply. We ensure you have uninterrupted access to water at all times.</li>
  <li><strong>Geyser for Hot Water:</strong> No more waiting for hot water! Every room comes with a geyser, offering 24-hour hot water supply for your convenience, especially during the colder months.</li>
  <li><strong>2-Wheeler Parking:</strong> For residents who drive, we provide secure 2-wheeler parking, ensuring your vehicle is safe and conveniently parked.</li>
  <li><strong>Fridge:</strong> We provide a fridge in the PG to store your food and beverages. Whether it's for quick snacks or meals, the fridge is at your disposal.</li>
  <li><strong>Gas Facility:</strong> Our gas facility ensures you can cook your own meals in a safe and convenient manner.</li>
  <li><strong>Free Housekeeping:</strong> Maintaining a clean living space is easy with free housekeeping services. We ensure your room and common areas are clean and hygienic at all times.</li>
  <li><strong>Free Electric Bill:</strong> Say goodbye to worrying about electricity bills! At Om Sai PG, we offer free electricity services, making your stay even more affordable.</li>
  <li><strong>Purified Drinking Water:</strong> Stay healthy with purified drinking water available at all times. We ensure that your drinking water is always clean and safe.</li>
  <li><strong>CCTV Security:</strong> Your safety is our priority! Om Sai PG is equipped with CCTV cameras for enhanced security, ensuring peace of mind for all residents.</li>
</ul>



<h1>Affordable Pricing Plans at Om Sai PG</h1>
<p>Om Sai PG offers a range of affordable accommodation options to suit your needs. All rooms come with breakfast and dinner included, providing you with nutritious meals throughout the day. Here are the options available:</p>
<ul>
  <li><strong>Single Sharing Room:</strong> ₹8,500 per month (including breakfast and dinner)</li>
  <li><strong>Double Sharing Room:</strong> ₹7,000 per month (including breakfast and dinner)</li>
  <li><strong>Triple Sharing Room:</strong> ₹6,000 per month (including breakfast and dinner)</li>
</ul>
<p>In addition to the rent, we require a deposit of ₹3,000 and one month's advance rent for all rooms.</p>

<h2>Convenient Location: Close to Eon IT Park</h2>
<p>Om Sai PG is conveniently located in Kharadi, a prime area near the Eon IT Park. This makes it an ideal choice for professionals working at the IT park or students attending nearby educational institutions. The proximity to key locations, public transport, and essential services adds to the appeal of living here.</p>

<h2>Contact Us</h2>
<p>If you're looking for a PG in Wagholi with all the modern amenities, Om Sai PG is the perfect choice for you. For more information or to book a room, please contact us at:</p>
<ul>
  <li><strong>Phone:</strong> 9763888448 | 9922248255</li>
</ul>

<h2>PG in Wagholi for Male</h2>
<p>Wagholi offers several well-furnished and affordable paying guest accommodations for men. Located in a prime area near IT hubs, educational institutions, and major roads, PG for males in Wagholi provides the perfect blend of comfort, convenience, and safety. With spacious rooms, essential amenities, and a homely environment, these PGs cater to working professionals and students alike. Enjoy 24/7 water supply, electricity, Wi-Fi, and security features in the heart of Pune's growing locality.</p>

<h2>PG in Wagholi for Female</h2>
<p>Wagholi offers a variety of options for women looking for safe, affordable, and well-maintained paying guest accommodations. The PG for females in Wagholi offers homely vibes with modern amenities like air-conditioned rooms, hot water, and nutritious home-cooked food. Ideal for students, working women, and professionals, these PGs are situated in safe neighborhoods and are equipped with 24/7 security and CCTV surveillance. Enjoy your stay with comfort and privacy while staying close to your workplace or college.</p>

<h2>PG in Wagholi for Students</h2>
<p>PG in Wagholi for students is an ideal accommodation choice for young minds who are looking for proximity to top universities, colleges, and coaching centers in Pune. These student PGs in Wagholi come with study tables, high-speed internet, and meal plans tailored to student needs. Whether you’re preparing for exams or focusing on your career, these PGs provide a quiet and conducive environment for study while being affordable. Spacious rooms, clean surroundings, and access to local markets make them the best choice for students in Wagholi.</p>

<h2>PG Near Wagholi</h2>
<p>You can find many budget-friendly and convenient paying guest accommodations just a short distance away from the Wagholi area. Whether you are a student, a working professional, or someone relocating to the area, PG near Wagholi offers great options with all essential facilities like food, internet, laundry, and more. Stay close to the bustling hub of Wagholi with easy connectivity to nearby workplaces, educational institutes, and entertainment spots.</p>

<h2>Hostel in Wagholi</h2>
<p>If you're considering a hostel in Wagholi, you’re in luck! There are many well-established hostels that provide accommodation for both male and female residents in this prime locality. Whether you are a student, a working professional, or looking for a temporary place to stay, hostels in Wagholi offer excellent services, including well-furnished rooms, food, and recreational facilities. The hostels in Wagholi are known for being budget-friendly and offering a homely environment with high security and all basic amenities.</p>

<h2>Hostel in Wagholi Pune</h2>
<p>Hostel accommodation in Wagholi provides the perfect option for students and working individuals. The hostels in Wagholi are well-connected to key locations in Pune, making commuting to work or college hassle-free. With clean rooms, nutritious food, and modern amenities like Wi-Fi and laundry facilities, hostels in Wagholi Pune offer an ideal living space for long-term stays. Experience comfort and security with fully furnished rooms and 24/7 security at affordable prices.</p>

<h2>Girls Hostel in Wagholi</h2>
<p>Female-friendly hostels in Wagholi offer a safe, secure, and homely environment for women. Whether you are a student or a professional, girls hostel in Wagholi provides facilities like private rooms, nutritious meals, Wi-Fi, and daily housekeeping. With strict security protocols, CCTV surveillance, and a supportive atmosphere, these hostels offer peace of mind to women living away from home in Pune. The proximity to schools, colleges, and workplaces makes these hostels the best option for women in Wagholi.</p>

<h2>Paying Guest in Wagholi</h2>
<p>Discover a range of PG accommodations designed to meet the needs of individuals seeking comfort and convenience. Whether you are a working professional or a student, paying guest in Wagholi offers fully furnished rooms, home-cooked meals, Wi-Fi, and 24/7 water and electricity. The area is well-connected to major roads and hubs in Pune, making it an excellent choice for those looking for a peaceful and affordable stay.</p>




            <h2>Om Sai PG for "PG In Pune" Contact Number:- </h2>
            <p>Contact Om Sai PG at +91 9763888448 / +91 9922248255. Our PG is strategically located in the heart of Kharadi, one of Pune's most vibrant and accessible neighborhoods, making it an ideal choice for students and professionals alike.</p>

            
              <table
                style={{
                  borderCollapse: "collapse",
                  width: "100%",
                  borderWidth: "0px",
                }}
                border="1"
              >
                <colgroup>
                  <col style={{ width: "49.9491%" }} />
                  <col style={{ width: "49.9491%" }} />
                </colgroup>
                <tbody>
                  <tr>
                    <td style={{ borderWidth: "0px" }}>
                    <p> - PG in Wagholi for Male</p>
<p> - PG in Wagholi for Female</p>
<p> - PG in Wagholi for Students</p>
<p> - PG Near Wagholi</p>


                    </td>
                    <td style={{ borderWidth: "0px" }}>
                    <p> - Hostel in Wagholi</p>
<p> - Hostel in Wagholi Pune</p>
<p> - Girls Hostel in Wagholi</p>
<p> - Paying Guest in Wagholi</p>

                    </td>
                  </tr>
                </tbody>
              </table>

              <h1>Why Choose Om Sai PG for PG in Wagholi?</h1>
<ol>
  <li><strong>Prime Location in Wagholi</strong><br/>Om Sai PG is conveniently located in Wagholi, a rapidly developing area in Pune. It's easily accessible from major transportation hubs, schools, colleges, IT parks, and commercial centers, making it ideal for students and professionals.</li>
  <li><strong>Fully Furnished and Comfortable Accommodation</strong><br/>We provide well-furnished rooms with modern amenities, ensuring that our residents have a comfortable and hassle-free stay. Our rooms come equipped with necessary furniture, including beds, wardrobes, study tables, and chairs, creating a cozy and conducive living environment.</li>
  <li><strong>24/7 Security and Surveillance</strong><br/>Your safety is our top priority. Om Sai PG offers round-the-clock security personnel and CCTV surveillance, providing a secure living space for all residents.</li>
  <li><strong>Hygienic and Well-Maintained Facilities</strong><br/>We believe in maintaining cleanliness and hygiene in all our facilities. Our rooms, common areas, bathrooms, and dining spaces are cleaned regularly, ensuring a healthy and fresh environment.</li>
  <li><strong>Affordable Rent and Flexible Payment Options</strong><br/>Om Sai PG offers budget-friendly rent packages, making it a great choice for students and working professionals. We also provide flexible payment options to suit your needs.</li>
  <li><strong>Home-Cooked Meals</strong><br/>We provide nutritious, home-cooked meals in our spacious dining area. Our food is freshly prepared, hygienic, and tailored to meet the diverse tastes and dietary preferences of our residents.</li>
  <li><strong>Fast Internet and Laundry Services</strong><br/>Stay connected with our high-speed Wi-Fi and make use of our laundry services for added convenience. We offer regular housekeeping and laundry services, ensuring you don't have to worry about everyday chores.</li>
  <li><strong>Friendly and Supportive Management</strong><br/>Our friendly staff is always available to help you with any concerns, queries, or requirements. The management team is approachable, ensuring a smooth and pleasant stay.</li>
  <li><strong>Ample Parking Space</strong><br/>For those who have their vehicles, Om Sai PG offers ample parking space within the premises, ensuring the safety and convenience of your vehicle.</li>
  <li><strong>Vibrant Community and Social Environment</strong><br/>At Om Sai PG, we aim to create a welcoming and vibrant community. Our PG provides an opportunity to interact with people from various backgrounds, making it easy to form lasting friendships.</li>
</ol>

              
              <div className="">
                  <h2>
                  FAQs for Om Sai PG in Wagholi ? 
                  </h2>
                  {faqs.map((faq, index) => (
                    <div key={index} className="faq-item">
                      <div
                        className={`faq-question ${
                          activeIndex === index ? "active" : ""
                        }`}
                        onClick={() => toggleAccordion(index)}
                      >
                        {index + 1}. {faq.question}
                      </div>
                      {activeIndex === index && (
                        <div className="faq-answer">{faq.answer}</div>
                      )}
                    </div>
                  ))}
                </div>


                  {/* ======================== */}
                  <div className="container">
                    <div className="testimonial-section">
                  <h2>
                  Testimonial for “Om Sai PG” for  PG in Wagholi :- {" "}
                  </h2>
                  <Slider {...settings}>
                    {testimonials.map((testimonial, index) => (
                      <div key={index} className="testimonial-slide">
                        <blockquote>
                          <p>{testimonial.quote}</p>
                          <footer>— {testimonial.author}</footer>
                        </blockquote>
                      </div>
                    ))}
                  </Slider>
                  </div>
                </div>

                {/* ================= */}
                <ContactNumber></ContactNumber>
            </div>
           <RecentPost></RecentPost>
        
        </div>
        </div>
      </div>
    </>
  );
}
